import { useClientInfoStore } from "@btcdirect/stores";

/**
 * Check if the current client is a desktop app that supports Apple Pay
 */
export function useDesktopAppWithApplePay(): boolean {
    const clientInfoStore = useClientInfoStore();

    const desktopAppsWithApplePay = ["ledger", "bitbox"];
    return desktopAppsWithApplePay.includes(clientInfoStore.client.slug);
}
